define('buildtimeConfig', {"version":"development"});